import { colors } from "assets/styles/colors";
import { Grid } from "assets/styles/globalStyles";
import { FontSizes } from "utils/enums";
import styled from "styled-components";

export const BooksWrapper = styled.div<any>`
    padding-top:145px;
    position:relative;
    min-height:100vh;
    width:100%;    
    direction:${(props) => props.direction};
`

export const BooksListWrap  =styled.div`
grid-gap: 25px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    margin: 20px 0;
    width: 100%;
`

export const BookItem = styled.div`
text-align:center;
cursor:pointer;
h1{
    margin:0
}

`
